export default __webpack_public_path__ + "21b635e004613d6803ed9d029487ae17.svg";